import { default as MuiInput } from '@mui/material/OutlinedInput'

import { createComponentWrapperWithRef } from '../../theme'

export { type InputBaseComponentProps } from '@mui/material/InputBase'
export const TextInput = createComponentWrapperWithRef(
  {
    mui: MuiInput,
    nova: MuiInput,
  },
  'TextInput',
)
